export enum AssessmentDefinitionStatus {
  Active = 1,
  Pending = 2,
  Inactive = 3,
}

export enum CompanyAssessmentStatus {
  NotStarted = 0,
  Incomplete,
  InProgress,
  ReadyToScore,
  Completed,
  NoneCompleted,
}

export enum UserAssessmentStatus {
  NotStarted = 0,
  Incomplete,
  InProgress,
  Completed,
}
